import React from 'react';
import PropTypes from 'prop-types';

import { QUERY_STATUS } from '@ion/api/audit-logs/query';

import visuallyHiddenStyle from './visuallyHiddenStyle';

function buildMessage(status, count) {
  if (status === QUERY_STATUS.ERROR) return 'Failed to load audit log entries';
  if (status === QUERY_STATUS.LOADING) return 'Loading audit log entries';
  return `${count} audit log ${count === 1 ? 'entry' : 'entries'}`;
}

export default function AuditLogStatus({ count, status }) {
  return (
    <span aria-live="polite" data-test-id="auditLogStatus" style={visuallyHiddenStyle}>
      {buildMessage(status, count)}
    </span>
  );
}

AuditLogStatus.propTypes = {
  count: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
};
